import * as Types from '../../types/bff/gql-schema';

import { useQuery, useMutation, UseQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetBannerAdExchangeDocument = `
    query GetBannerAdExchange($request: BannerAdExchangeRequestInput!) {
  getBannerAdExchange(request: $request) {
    bannerAdId
    bannerImageUrl
    clickAction {
      clickActionType
      outlink
      phoneNumber
    }
    colorTheme
    ctaButtonLabel
    deliberatedCode
    longSubTitle
    subTitle
    longTitle
    title
    targetPlaceCode
    content
    badges {
      content
    }
  }
}
    `;
export const useGetBannerAdExchangeQuery = <
      TData = Types.GetBannerAdExchangeQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetBannerAdExchangeQueryVariables,
      options?: UseQueryOptions<Types.GetBannerAdExchangeQuery, TError, TData>,
    ) =>
    useQuery<Types.GetBannerAdExchangeQuery, TError, TData>(
      ['GetBannerAdExchange', variables],
      gqlFetcher<Types.GetBannerAdExchangeQuery, Types.GetBannerAdExchangeQueryVariables>(GetBannerAdExchangeDocument, 'GetBannerAdExchange', variables),
      options
    );

useGetBannerAdExchangeQuery.getKey = (variables: Types.GetBannerAdExchangeQueryVariables) => ['GetBannerAdExchange', variables];
;

useGetBannerAdExchangeQuery.fetcher = (variables: Types.GetBannerAdExchangeQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetBannerAdExchangeQuery, Types.GetBannerAdExchangeQueryVariables>(GetBannerAdExchangeDocument, 'GetBannerAdExchange', variables, options);
export const HandleAdExposureDocument = `
    mutation HandleAdExposure($request: AdExposureHandleMutationRequestInput!) {
  handleAdExposure(request: $request)
}
    `;
export const useHandleAdExposureMutation = <
      TError = Types.GraphqlError,
      TContext = unknown
    >(options?: UseMutationOptions<Types.HandleAdExposureMutation, TError, Types.HandleAdExposureMutationVariables, TContext>) =>
    useMutation<Types.HandleAdExposureMutation, TError, Types.HandleAdExposureMutationVariables, TContext>(
      ['HandleAdExposure'],
      (variables?: Types.HandleAdExposureMutationVariables) => gqlFetcher<Types.HandleAdExposureMutation, Types.HandleAdExposureMutationVariables>(HandleAdExposureDocument, 'HandleAdExposure', variables)(),
      options
    );
useHandleAdExposureMutation.fetcher = (variables: Types.HandleAdExposureMutationVariables, options?: RequestInit['headers']) => gqlFetcher<Types.HandleAdExposureMutation, Types.HandleAdExposureMutationVariables>(HandleAdExposureDocument, 'HandleAdExposure', variables, options);